import { Flow_0_0_2 } from '@flexus/core';
import { SIL_97 } from './SIL_97';

export const SIL_89: Flow_0_0_2 = {
	id: '89',
	name: 'internal_assessor_job',
	itemType: 'flow',
	fetchLevel1And2: true,
	header: {
		...SIL_97.header
	},
	footer: {
		...SIL_97.footer
	},
	instructions: {
		...SIL_97.instructions
	},
	actionPanel: SIL_97.actionPanel,
	serverCalls: {
		...SIL_97.serverCalls
	},
	startNode: 'AssessorOverview',
	nodes: {
		...SIL_97.nodes
	},
	bigFormToStoreMapper: {
		...SIL_97.bigFormToStoreMapper
	}
};
